import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { OFFER, BRAND } from '../lib/content';
import { Reveal } from './Reveal';
import { Button } from './ui/Button';
const FEATURE_CARDS = [{
  emoji: '🤖',
  text: 'Mini Constructores completo',
  bg: 'bg-[#F4F5FF]'
}, {
  emoji: '🧩',
  text: '+150 proyectos para crear',
  bg: 'bg-[#FFF5ED]'
}, {
  emoji: '🎥',
  text: 'Videos paso a paso',
  bg: 'bg-[#EBF7ED]'
}, {
  emoji: '🖨️',
  text: 'Plantillas imprimibles',
  bg: 'bg-[#FFF9E6]'
}, {
  emoji: '🎁',
  text: '14 BONOS INCLUIDOS',
  bg: 'bg-[#FFF0E5]',
  highlight: true
}, {
  emoji: '⚡',
  text: 'Acceso inmediato',
  bg: 'bg-[#F0F7FF]'
}, {
  emoji: '♾️',
  text: 'Acceso de por vida',
  bg: 'bg-[#F4F5FF]'
}, {
  emoji: '🏠',
  text: 'Materiales de casa',
  bg: 'bg-[#EBF7ED]'
}];
export function Offer() {
  return <section id="comprar" className="w-full bg-gradient-to-b from-[#0F2A55] to-[#1C3587] pt-16 sm:pt-24" data-id="element-285" data-mp="2famrt0ruwxhs">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-286" data-mp="2actnyee10fko">
        <Reveal className="relative text-center" data-id="element-287" data-mp="pl0c5sqx5sdc">
          {/* Decorative Stars */}
          <div className="absolute left-0 top-0 text-xl opacity-80" aria-hidden="true" data-id="element-288" data-mp="uisgjm8r36yf">✨</div>
          <div className="absolute right-0 top-12 text-2xl opacity-80" aria-hidden="true" data-id="element-289" data-mp="ziobkvzgzo1u">⭐</div>

          <span className="inline-flex items-center gap-1.5 rounded-full bg-[#FF6B35] px-4 py-1.5 font-display text-[10px] font-black uppercase tracking-widest text-white shadow-sm sm:text-xs" data-id="element-290" data-mp="13jqafbph5y3a">
            {OFFER.badge.replace('🔥 ', '✨ ')}
          </span>
          
          <h2 className="mt-6 text-4xl font-black leading-tight text-white sm:text-6xl font-sans" data-id="element-291" data-mp="bqpyq7kdhkml">
            {OFFER.title}
          </h2>
          
          <p className="mx-auto mt-4 max-w-md text-[15px] font-bold leading-snug text-white/90 sm:text-lg" data-id="element-292" data-mp="kle3zxpy72be">
            Solo por hoy te llevás el acceso completo a <span className="text-[#FF8C22]" data-id="element-293" data-mp="3k6t426o0ix7r">Mini Constructores + 14 bonos incluidos.</span>
          </p>

          <div className="mx-auto mt-6 w-full max-w-md rounded-xl bg-[#2A3B66] px-4 py-3 shadow-inner" data-id="element-294" data-mp="3o7uxg6v90f1t">
            <h3 className="font-display text-[11px] font-black uppercase tracking-widest text-white sm:text-sm" data-id="element-295" data-mp="qgnpa9vnisgj">
              {OFFER.productTitle}
            </h3>
          </div>
        </Reveal>

        <Reveal className="mt-8" delay={0.1} float={true} data-id="element-296" data-mp="106h19bzph9lb">
          <div className="overflow-hidden rounded-3xl shadow-2xl" data-id="element-297" data-mp="106z5ausm0s3s">
            <img src="https://cdn.magicpatterns.com/uploads/uuDcTTCqQN9Dqr9Z4bE3Jz/ChatGPT_Image_26_jul_2026,_21_47_53.webp" alt="Mini Constructores Bundle" className="w-full object-cover" data-id="element-298" data-mp="cg381i5dx4p5" />
          </div>
        </Reveal>
      </div>

      <div className="mx-auto mt-8 w-full max-w-4xl px-4 sm:mt-12 sm:px-8" data-id="element-299" data-mp="hfg5sxxsnw6i">
        <Reveal delay={0.2} data-id="element-300" data-mp="1wwq0kw8q6jan">
          <div className="rounded-t-[2rem] bg-white px-5 py-8 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] sm:rounded-[2.5rem] sm:px-12 sm:py-12 pt-[16px]" data-id="element-301" data-mp="1wvygoiohqa07">
            <h3 className="text-center font-display text-2xl font-black text-[#1C3587] sm:text-4xl" data-id="element-302" data-mp="1sx7h84wjyg9x">
              {OFFER.subtitle}
            </h3>
            
            <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-303" data-mp="25erxc00249cz">
              {FEATURE_CARDS.map((feature, i) => <Reveal key={i} delay={i * 0.05} float={true} data-id="element-304" data-mp="1qikhtczlfw41" data-mpi={i}>
                  <div className={`relative flex h-full flex-col items-center justify-center gap-2 rounded-2xl p-4 text-center shadow-sm ${feature.bg}`} data-id="element-305" data-mp="1vgm2218ra1h3">
                    <div className="absolute left-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#22C55E] shadow-sm" data-id="element-306" data-mp="2o48c9scho4cx">
                      <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} data-id="element-307" data-mp="29eald4n6d0k1" />
                    </div>
                    <span className="text-2xl" aria-hidden="true" data-id="element-308" data-mp="2ed3zmzaacvl9">{feature.emoji}</span>
                    <span className={`font-display text-[11px] font-black leading-tight ${feature.highlight ? 'text-[#FF6B35]' : 'text-[#1C3587]'}`} data-id="element-309" data-mp="322yaxceyic3e">
                      {feature.text}
                    </span>
                  </div>
                </Reveal>)}
            </div>

            <div className="mt-10 flex flex-col items-center border-t border-gray-100 pt-10 text-center" data-id="element-310" data-mp="1e71sk4gehtwr">
              {/* Pricing */}
              <div className="flex flex-col items-center" data-id="element-311" data-mp="198gry3x8l87s">
                <span className="font-display text-lg font-black text-gray-400 line-through" data-id="element-312" data-mp="149x766udq2h0">
                  Antes: {BRAND.compareAtPrice}
                </span>
                <span className="mt-1 font-display text-xl font-black text-[#1C3587]" data-id="element-313" data-mp="1wxt0d1kqpc91">
                  Hoy
                </span>
                <div className="font-display text-[4.5rem] font-black leading-none text-[#3B5BDB] sm:text-[5.5rem] flex items-baseline justify-center gap-2" data-id="element-314" data-mp="1s6ax26v8uzkw">
                  {BRAND.price}
                  <span className="text-xl sm:text-3xl font-bold text-[#3B5BDB]/60 uppercase tracking-widest" data-id="element-315" data-mp="2knx5jddktk25">{BRAND.currency}</span>
                </div>
                <div className="mt-3 flex items-center gap-2 font-display text-[15px] font-bold text-gray-600" data-id="element-316" data-mp="2fukfqzx5v77t">
                  <span className="text-sky-500" data-id="element-317" data-mp="2o7ntm9qcn5nu">💳</span> {BRAND.installments}
                </div>
              </div>

              {/* Animated Button */}
              <motion.a href={BRAND.checkoutUrl} animate={{
              scale: [1, 1.03, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }} className="mt-8 flex w-full max-w-md items-center justify-center rounded-2xl bg-[#22C55E] py-4 font-display text-lg font-black uppercase tracking-wide text-white shadow-[0_8px_30px_rgba(34,197,94,0.3)] transition-colors hover:bg-[#16A34A] sm:py-5 sm:text-xl" data-id="element-318" data-mp="2x57wto7rvc13">
                {BRAND.ctaLabel}
              </motion.a>

              <p className="mt-4 text-[13px] font-bold text-gray-500" data-id="element-319" data-mp="3ku8y8ri6tmwv">
                {OFFER.disclaimer}
              </p>

              {/* Security Badge 1 */}
              <div className="mt-6 flex w-full max-w-md items-center gap-4 rounded-2xl border border-[#86EFAC] bg-[#F0FDF4] p-4 text-left shadow-sm" data-id="element-320" data-mp="3ut87ocas1mkx">
                <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-[#22C55E] text-white shadow-sm" data-id="element-321" data-mp="355vr3tlcvreq">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" data-id="element-322" data-mp="3evfd384d81dt">
                    <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clipRule="evenodd" data-id="element-323" data-mp="3a45pse6aha53" />
                  </svg>
                </div>
                <p className="font-display text-[13px] font-bold leading-tight text-[#166534] sm:text-sm" data-id="element-324" data-mp="1olw5e1phppi">
                  Compra 100% segura y protegida por Mercado Pago.
                </p>
              </div>

              {/* Security Badge 2 */}
              <div className="mt-4 flex w-full max-w-md justify-center" data-id="element-325" data-mp="23gijdkx8ko04">
                <img src="https://cdn.magicpatterns.com/uploads/jGMq9oVyZa6bet56YLBSwD/capture_260410_163646.png" alt="Pago seguro garantizado con Visa, Mastercard, American Express y Mercado Pago" className="w-full h-auto object-contain" data-id="element-326" data-mp="1yi78d6v7g7gb" />
              </div>

              {/* Warning Badge */}
              <div className="mt-4 flex max-w-md items-center justify-center rounded-2xl bg-gradient-to-r from-[#8B2C1A] to-[#B93815] p-4 shadow-md pr-[14px] w-[331px] h-[32px]" data-id="element-327" data-mp="984z14ugudp0">
                <p className="font-display font-bold text-white text-[11px]" data-id="element-328" data-mp="3rgdvyckg45ou">
                  ⚠️ Precio promocional disponible solamente por hoy
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}